<template>

    <div class="container">
        <div class="box-auth">
            <div class="box-auth-main" style="position: relative">
                <h3 class="auth-box-title mb-20" v-if="role_type == 0" >{{$t('lisa_web_register_student')}}</h3>
                <h3 class="auth-box-title mb-20" v-if="role_type == 1" >{{$t('lisa_web_register_parent')}}</h3>
                <a href="/login">
                    <img class="icon-closed" src="/themes/ito/images/icon-closed.svg" alt=""> 
                </a>
                <div :class="screen == 1?'screen-show':'screen-hide'">
                    <div class="line-status">
                        <div class="d-flex justify-content-between">
                            <div class="line"></div>
                            <div class="node active"></div>
                            <div class="node"></div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="lisa-label-input">{{$t('full_name')}}<span class="red">*</span></label>
                        <input type="text" :class="errors.fullname?'lisa-input has-err':'lisa-input'" name="fullname"
                               :placeholder="$t('enter_your_full_name')"
                               autocomplete="off" @input="addEvent1" v-model="user.fullname"
                               @keyup.enter="valid_1 && changeScreen(2)" />
                    </div>
                    <div class="form-group" v-if="role_type == 0">
                        <label class="lisa-label-input">{{$t('grade')}}<span class="red">*</span></label>
                        <select v-if="system=='Lisa'" class="lisa-input" name="grade" v-model="user.grade"
                                title="Choose your grade" @change="addEvent1" @keyup.enter="valid_1 && changeScreen(2)" >
                            <option value="6">6</option>
                            <option value="7">7</option>
                            <option value="8">8</option>
                            <option value="9">9</option>
                        </select>
                        <select v-if="system=='MGS'" class="lisa-input" name="grade" v-model="user.grade"
                                title="Choose your grade" @change="addEvent1" @keyup.enter="valid_1 && changeScreen(2)" >
                            <option value="1">1</option>
                            <option value="2">2</option>
                            <option value="3">3</option>
                            <option value="4">4</option>
                            <option value="5">5</option>
                            <option value="6">6</option>
                            <option value="7">7</option>
                            <option value="8">8</option>
                            <option value="9">9</option>
                            <option value="10">10</option>
                            <option value="11">11</option>
                            <option value="12">12</option>
                        </select>
                    </div>
                    <div class="form-group">
                        <label class="lisa-label-input">{{$t('phone')}}</label>
                        <input type="text" :class="errors.phone?'lisa-input has-err':'lisa-input'" name="phone"
                               :placeholder="$t('enter_your_phone_number')"
                               autocomplete="off" @input="addEvent1" v-model="user.phone" id="phone"
                               @keyup.enter="valid_1 && changeScreen(2)" />
                    </div>
                    <div class="d-flex">
                        <div class="form-group" style="width: calc(50% - 5px);"  v-if="role_type == 1">
                            <label class="lisa-label-input" style="font-size:12px">{{$t('relationship')}}</label>
                            <select class="lisa-input" name="relationship" v-model="user.relationship"
                                    title="Choose your relationship" @change="addEvent1" style="width: 100%">
                                <!-- <option value="">
                                    {{$t('choose_relationship')}}
                                </option> -->
                                <option value="father">
                                    {{$t('father')}}
                                </option>
                                <option value="mother">
                                    {{$t('mother')}}
                                </option>
                            </select>
                        </div>
                        <div class="form-group" style="width: calc(50% - 5px);"  v-if="role_type == 0">
                            <label class="lisa-label-input" style="font-size:12px">{{$t('gender')}}</label>
                            <select class="lisa-input" name="gender" v-model="user.gender"
                                    title="Choose your gender" @change="addEvent1" style="width: 100%">
                                <!-- <option value="">
                                    {{$t('choose_gender')}}
                                </option> -->
                                <option value="male">
                                    {{$t('male')}}
                                </option>
                                <option value="female">
                                    {{$t('female')}}
                                </option>
                            </select>
                        </div>
                        <div class="form-group" style="margin-left: 10px; width: calc(50% - 5px);">
                            <label class="lisa-label-input" style="font-size:12px">{{$t('date_of_birth')}}</label>
                            <img class="icon-birthday" src="/themes/ito/images/icon-birthday.svg">
                            <input readonly="true" type="text" class="date1 datepicker birthday"
                                   :class="errors.birthday?'lisa-input has-err':'lisa-input'" name="birthday"
                                   :placeholder="$t('birthday')"
                                   autocomplete="off" v-model="user.birthday" @keyup.enter="valid_1 && changeScreen(2)" 
                                   style="width: 100%"/>
                        </div>
                    </div>
                    <div class="d-flex">
                        <div class="form-group" style="width: calc(50% - 5px);">
                            <label class="lisa-label-input" style="font-size:12px">{{ $t('province') }}<span class="red">*</span></label>
                            <select class="lisa-input" style="width: 100%" name="province" v-model="user.province_id" 
                                :title="$t('choose_province')" @change="addEvent1" @keyup.enter="valid_1 && changeScreen(2)">
                                <option :value="null">
                                    {{ $t('choose_province') }}
                                </option>
                                <option :value="province.id" v-for="(province, index) in provinceOptions" :key="index">{{ province.name }}</option>
                            </select>
                        </div>
                        <div class="form-group" style="margin-left: 10px; width: calc(50% - 5px);">
                            <label class="lisa-label-input" style="font-size:12px">{{ $t('ward') }}<span class="red">*</span></label>
                            <select class="lisa-input" style="width: 100%" name="ward" v-model="user.ward_id" 
                                :title="$t('choose_ward')" @change="addEvent1" @keyup.enter="valid_1 && changeScreen(2)">
                                <option :value="null">
                                    {{ $t('choose_ward') }}
                                </option>
                                <option :value="ward.id" v-for="(ward, index) in wardOptions" :key="index">{{ ward.name }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="form-group d-flex justify-content-center align-items-center">
                        <div :class="valid_1?'lisa-btn-fit active':'lisa-btn-fit'"
                             @click="valid_1?changeScreen(2):''">
                             <p>{{$t('next')}}</p>
                        </div>
                    </div>
                    <div class="error-message text-center" v-if="errors.fullname">{{ $t(`${errors.fullname}`) }}</div>
                    <div class="error-message text-center" v-if="errors.phone">{{ $t(`${errors.phone}`) }}</div>
                    <div class="error-message text-center" v-if="errors.gender">{{ $t(`${errors.gender}`) }}</div>
                    <div class="error-message text-center" v-if="errors.relationship">{{ $t(`${errors.relationship}`) }}</div>
                    <div class="error-message text-center" v-if="errors.birthday">{{ $t(`${errors.birthday}`) }}</div>
                </div>
                <div :class="screen == 2?'screen-show':'screen-hide'">
                    <img class="register-back" src="/themes/web/assets/images/icon-calender-prev.svg"
                         @click="changeScreen(1)"/>
                    <div class="line-status">
                        <div class="d-flex justify-content-between">
                            <div class="line"></div>
                            <div class="node active"></div>
                            <div class="node active"></div>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="form-group">
                            <label class="lisa-label-input">{{$t('username')}}<span class="red">*</span></label>
                            <input type="text" :class="errors.username?'lisa-input has-err':'lisa-input'"
                                   name="username"
                                   :placeholder="$t('enter_your_username_8_15_characters')"
                                   autocomplete="off" @input="addEvent2" v-model="user.username"
                                   @keyup.enter="valid_2?onSubmit():''"/>
                        </div>
                        <div class="form-group">
                            <label class="lisa-label-input">{{$t('email')}}<span class="red">*</span></label>
                            <input type="text" :class="errors.email?'lisa-input has-err':'lisa-input'" name="email"
                                   :placeholder="$t('enter_your_e_mail')"
                                   autocomplete="off" @input="addEvent2" v-model="user.email"
                                   @keyup.enter="valid_2?onSubmit():''"/>
                        </div>
                        <label class="lisa-label-input">{{$t('password')}}<span class="red">*</span></label>
                        <div class="input-pass">
                            <input :type="showPass ? 'text' : 'password'"
                                   :class="errors.password?'lisa-input has-err':'lisa-input'" id="password-field"
                                   name="password"
                                   :placeholder="$t('enter_your_password')"
                                   autocomplete="off" @input="addEvent2" v-model="user.password"
                                   @keyup.enter="valid_2?onSubmit():''"/>
                            <span :class="[showPass ? 'icon-eye eye-show' : 'icon-eye eye-hide']"
                                  @click="showPass = !showPass"></span>
                        </div>
                        <label class="lisa-label-input" style="margin-top: 10px">{{$t('confirm_password')}}<span class="red">*</span></label>
                        <div class="input-pass">
                            <input :type="showConfirm ? 'text' : 'password'"
                                   :class="errors.password_confirm?'lisa-input has-err':'lisa-input'"
                                   id="password-confirm" name="password_confirm"
                                   :placeholder="$t('enter_your_password_again')"
                                   autocomplete="off" @input="addEvent2" v-model="user.password_confirm"
                                   @keyup.enter="valid_2?onSubmit():''"/>
                            <span :class="[showConfirm ? 'icon-eye eye-show' : 'icon-eye eye-hide']"
                                  @click="showConfirm = !showConfirm"></span>
                        </div>
                    </div>
                    <div class="form-group d-flex justify-content-center">
                        <div :class="valid_2? 'lisa-btn-fit lisa-btn-submit active':'lisa-btn-fit'"
                             @click="valid_2? onSubmit() : ''">{{$t('next')}}
                        </div>
                    </div>
                    <div class="error-message text-center" v-if="errors.username">{{ $t(`${errors.username}`) }}</div>
                    <div class="error-message text-center" v-if="errors.email">{{ $t(`${errors.email}`) }}</div>
                    <div class="error-message text-center" v-if="errors.password">{{ $t(`${errors.password}`) }}</div>
                    <div class="error-message text-center" v-if="errors.password_confirm">{{ $t(`${errors.password_confirm}`)
                        }}
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" style="" id="RegisterSuccessPopup" tabindex="-1" role="dialog"
             aria-labelledby="RegisterSuccessPopup" aria-hidden="true" data-backdrop="static" data-keyboard=false>
            <div class="modal-dialog modal-dialog-centered d-flex justify-content-center" role="document">
                <div class="modal-content box-shadow-main">
                    <!--<div class="close-popup" data-dismiss="modal"></div>-->
                    <div style="position:relative">
                        <h3 class="popup-title">{{$t('congratulation')}}</h3>   
                        <a href="/login">
                            <img class="icon-closed" src="/themes/ito/images/icon-closed.svg" alt=""> 
                        </a>
                    </div>
                    <p class="mb-16" v-html="$t('p_reg_text01')"></p>
                    <!-- <p>{{$t('let_start')}}</p> -->
                    <div class="form-group d-flex justify-content-between" style="display: flex; padding:0 20px">
                        <a href="/connect-account-home" class="lisa-btn d-flex align-items-center" data-dismiss="modal" style="background: #FFCE43; color: #000000;">
                            {{$t("p_reg_btn01")}}
                        </a>
                        <a class="lisa-btn d-flex  align-items-center ito-btn-white mt-10" href="/connect-account-home"
                           style="background: #FD970C; color: #FFFFFF;"> {{$t("p_mapping_title")}}
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" id="RegisterStudentSuccessPopup" tabindex="-1" role="dialog"
             aria-labelledby="RegisterStudentSuccessPopup" aria-hidden="true" data-backdrop="static" data-keyboard=false>
            <div class="modal-dialog modal-dialog-centered d-flex justify-content-center" role="document">
                <div class="modal-content box-shadow-main">
                    <!--<div class="close-popup" data-dismiss="modal"></div>-->
                    <div style="position:relative">
                        <h3 class="popup-title mb-20">{{$t("congratulation")}}</h3>
                        <a href="/login">
                            <img class="icon-closed" src="/themes/ito/images/icon-closed.svg" alt=""> 
                        </a>
                    </div>
                    <p v-html="$t('lisa_web_p_reg_text01')"></p>
                    <!-- <p>{{$t('you_need_to_upgrade_your_account_to_get_full_course')}}</p> -->
                    <!--<div class="form-group">-->
                        <!--<a class="btn btn-main" href="/upgrade-account" style="display:block">Upgrade account</a>-->
                        <!--<a class="lisa-btn mt-2" href="/" style="background: #ffffff; border: 1px solid #000; margin: auto;color: #000;">Go to home page-->
                        <!--</a>-->
                    <!--</div>-->
                    <div class="form-group d-flex justify-content-center" style="display: flex">
                        <!-- <a class="lisa-btn d-flex  align-items-center"  href="/" data-dismiss="modal" style="background: #FFCE43; color: #000000;">{{$t("continue_free_trial")}}
                        </a>
                        <a class="lisa-btn d-flex  align-items-center ito-btn-white mt-10" href="/upgrade-account"
                           style="background: #FD970C; color: #FFFFFF;">{{$t('upgrade_account')}}
                        </a> -->
                        <a class="lisa-btn d-flex  align-items-center"  href="/" data-dismiss="modal" style="background: #FD970C; color: #FFFFFF">{{$t("lisa_web_go_home_page")}}
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <!--<div class="modal fade" id="UpgradeAccountPopup" tabindex="-1" role="dialog"-->
             <!--aria-labelledby="UpgradeAccountPopup" aria-hidden="true" data-backdrop="static" data-keyboard=false>-->
            <!--<div class="modal-dialog modal-dialog-centered ito-popup-large" role="document">-->
                <!--<div class="modal-content box-shadow-main">-->
                    <!--<div class="close-popup" data-dismiss="modal"></div>-->
                    <!--<h3 class="popup-title mb-20">Unclock full access</h3>-->
                    <!--<div class="select-upgrade-type d-flex mb-20">-->
                        <!--<div class="package package-1 box-shadow-main">-->
                            <!--<div class="package-title">PLUS ACCOUNT</div>-->
                            <!--<div class="package-price">75,000 vnđ / tháng</div>-->
                            <!--<div class="package-content">-->
                                <!--<div class="package-items d-flex">-->
                                    <!--<img src="/themes/ito/images/tick-1.svg">-->
                                    <!--<div class="package-items-text">iSmart Maths & Science: Vocabulary,-->
                                        <!--Presentation, Practices.-->
                                    <!--</div>-->
                                <!--</div>-->
                                <!--<div class="package-items d-flex">-->
                                    <!--<img src="/themes/ito/images/tick-1.svg">-->
                                    <!--<div class="package-items-text">iSmart Maths & Science: Fact Reading, Home-->
                                        <!--Science, 4-skill Extended.-->
                                    <!--</div>-->
                                <!--</div>-->
                                <!--<div class="package-items d-flex">-->
                                    <!--<img src="/themes/ito/images/tick-1.svg">-->
                                    <!--<div class="package-items-text">General English: much more content than-->
                                        <!--STANDARD-->
                                    <!--</div>-->
                                <!--</div>-->
                            <!--</div>-->
                        <!--</div>-->
                        <!--<div class="package package-2 box-shadow-main">-->
                            <!--<div class="package-title">PRO ACCOUNT</div>-->
                            <!--<div class="package-price">199,000 vnđ / tháng</div>-->
                            <!--<div class="package-content package-content-2">-->
                                <!--<div class="package-items d-flex">-->
                                    <!--<img src="/themes/ito/images/tick-2.svg">-->
                                    <!--<div class="package-items-text">iSmart Maths & Science: Vocabulary,-->
                                        <!--Presentation, Practices.-->
                                    <!--</div>-->
                                <!--</div>-->
                                <!--<div class="package-items d-flex">-->
                                    <!--<img src="/themes/ito/images/tick-2.svg">-->
                                    <!--<div class="package-items-text">iSmart Maths & Science: Fact Reading, Home-->
                                        <!--Science, 4-skill Extended.-->
                                    <!--</div>-->
                                <!--</div>-->
                                <!--<div class="package-items d-flex">-->
                                    <!--<img src="/themes/ito/images/tick-2.svg">-->
                                    <!--<div class="package-items-text">General English: much more content than-->
                                        <!--STANDARD.-->
                                    <!--</div>-->
                                <!--</div>-->
                                <!--<div class="package-items d-flex">-->
                                    <!--<img src="/themes/ito/images/tick-2.svg">-->
                                    <!--<div class="package-items-text">IGS-Bridge</div>-->
                                <!--</div>-->
                            <!--</div>-->
                        <!--</div>-->
                    <!--</div>-->
                    <!--<div class="form-group d-flex justify-content-center">-->
                        <!--<div class="ito-btn-large">Upgrade account</div>-->
                    <!--</div>-->
                <!--</div>-->
            <!--</div>-->
        <!--</div>-->
    </div>

</template>

<script>
    import {authRegister, authAnonymous} from '../../models/auth'
    import axios from "axios";
    import {showDialog} from '../../utils/dialog'
    import {mapGetters} from 'vuex'
    import {cloneDeep} from "lodash";

    export default {
        name: "Register",
        data() {
            return {
                errors: {
                    username: '',
                    fullname: '',
                    phone: '',
                    email: '',
                    gender: '',
                    relationship: '',
                    birthday: '',
                    grade: '',
                    province: '',
                    ward: '',
                    password: '',
                    password_confirm: ''
                },
                user: {
                    username: '',
                    fullname: '',
                    phone: '',
                    email: '',
                    gender: 'male',
                    relationship: 'father',
                    role_type: 0,
                    birthday: '',
                    grade: '6',
                    password: '',
                    password_confirm: '',
                    province_id: null,
                    ward_id: null
                },
                showPass: false,
                showConfirm: false,
                screen: 1,
                valid_1: false,
                valid_2: false,
                valid_3: false,
                type: 'student',
                role_type: 0,
                validate: 0,
                provinceOptions: [],
                wardOptions: [],
                system: process.env.VUE_APP_TITLE,  
            };
        },

        created() {
            const query = this.$route.query;
            this.type = query.type;
            if (!this.type || this.type == 'student') {
                this.role_type = 0;
            } else {
                this.role_type = 1;
            }
            this.fetch()
        },
        computed: {
            ...mapGetters([
                'user_info'
            ], () => {
                if (this.user_info) {
                    return this.user_info
                }

                return this.user
            }),
            configs() {
                return this.$store.state.configs
            },
        },
        watch: {
            configs: {
                handler(cfg) {
                    this.provinceOptions = cfg?.provinces || [];
                },
                immediate: true,
                deep: true
            },

            'user.province_id': {
                handler(value) {
                    this.wardOptions = this.provinceOptions.find(p => (p.id == value))?.Ward || [];
                    if (!this.wardOptions.find(w => w.id === this.user.ward_id?.id)) {
                        this.user.ward_id = null;
                    }
                    console.log("wardOptions:", this.user.ward_id);
                },
                immediate: true
            }
        },
        mounted() {

        },
        methods: {
            fetch() {
                this.$nextTick(function () {
                    //initDatepicker();

                    $('.birthday').datepicker({
                        dateFormat: 'dd/mm/yy',
                        changeMonth: true,
                        changeYear: true,
                        showOtherMonths: true,
                        selectOtherMonths: false,
                        yearRange: '1900:+0',
                        maxDate: new Date(),
                        monthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
                    }).on('change', (e) => {
                        this.addEvent1(e);
                    });
                });
            },
            searchEvent({target}) {
                this.user[target.name] = target.value;
            },
            formatDate(input) {
                return input.split("/").reverse().join("-")
            },
            changeScreen($screen) {
                this.screen = $screen;
            },
            addEvent1({target}) {
                switch (target.name) {
                    case 'fullname':
                        this.user.fullname = target.value;
                        break;
                    case 'phone':
                        this.user.phone = target.value;
                        break;
                    case 'relationship':
                        this.user.relationship = target.value;
                        break;
                    case 'gender':
                        this.user.gender = target.value;
                        break;
                    case 'birthday':
                        this.user.birthday = target.value;
                        break;
                    case 'grade':
                        this.user.grade = target.value;
                        break;
                    case 'province':
                        this.user.province_id = target.value;
                        break;
                    case 'ward':
                        this.user.ward_id = target.value;
                        break;
                }
                if (!this.eventValid1({target})) {
                    this.valid_1 = false;
                    return false;
                }
                if(this.role_type == 0){
                    if (this.eventValid1({target})
                        && this.user.fullname != '' && this.user.grade != '' && this.user.province_id && this.user.ward_id) {
                        this.valid_1 = true;
                    } else {
                        this.valid_1 = false;
                    }
                }else{
                    if (this.eventValid1({target})
                        && this.user.fullname != '') {
                        this.valid_1 = true;
                    } else {
                        this.valid_1 = false;
                    }
                }

            },
            addEvent2({target}) {
                switch (target.name) {
                    case 'username':
                        this.user.username = target.value;
                        break;
                    case 'email':
                        this.user.email = target.value;
                        break;
                    case 'password':
                        this.user.password = target.value;
                        break;
                    case 'password_confirm':
                        this.user.password_confirm = target.value;
                        break;
                }
                if (!this.eventValid2({target})) {
                    this.valid_2 = false;
                    return false;
                }
                if (this.eventValid2({target})
                    && this.user.username != ''
                    && this.user.email != ''
                    && this.user.password != ''
                    && this.user.password_confirm != '' && this.validateAll(this.user)) {
                        console.log(this.user.username,this.user.email,this.user.password,this.user.password_confirm);
                        console.log("s:", target);

                    this.valid_2 = true;
                } else {
                    this.valid_2 = false;
                }
            },
            eventValid1({target}) {
                let is_valid = true;
                switch (target.name) {
                    case 'fullname':
                        this.errors.fullname = '';
                        if (this.user.fullname == '') {
                            this.errors.fullname = "fullname_is_not_empty";
                            is_valid = false;
                        }
                        if (this.regexSpecialChar(this.user.fullname)) {
                            this.errors.fullname = "fullname_must_not_contain_special_characters";
                            is_valid = false;
                        }
                        break;
                    case 'phone':
                        this.errors.phone = '';
                        if (this.isNumeric(this.user.phone) == false) {
                            this.errors.phone = "validator_phone";
                            is_valid = false;
                        }
                        if (this.user.phone.length > 10) {
                            this.errors.phone = "phone_number_invalid";
                            is_valid = false;
                        }
                        break;
                    case 'grade':
                        this.errors.grade = '';
                        if (this.user.grade == '' && this.role_type == 0) {
                            this.errors.grade = "error_006";
                            is_valid = false;
                        }
                        break;
                    case 'province':
                        this.errors.province = '';
                        if (this.user.province_id == '') {
                            this.errors.province = this.$i18n.t('choose_province');
                            is_valid = false;
                        }
                        break;
                    case 'ward':
                        this.errors.ward = '';
                        if (this.user.ward_id == '') {
                            this.errors.ward = this.$i18n.t('choose_ward');
                            is_valid = false;
                        }
                        break;
                }
                return is_valid;
            },
            validateAll(user){
                let is_valid = true
                if (user.username.length < 8 || user.username.length > 15) {
                    is_valid = false;
                }
                if (this.regexSpecialChar(user.username)) {
                    is_valid = false;
                }
                if (this.validateVietnameseChar(user.username)) {
                    is_valid = false;
                }
                if (user.password == '') {
                    is_valid = false;
                }
                if (user.password.length < 8) {
                    is_valid = false;
                }
                if (this.validateVietnameseChar(user.password)) {
                    is_valid = false;
                }
                if (user.password_confirm == '') {
                    is_valid = false;
                }
                if (user.password_confirm != user.password) {
                    is_valid = false;
                }
                console.log("csadas: ", is_valid);
                return is_valid
            },
            eventValid2({target}) {
                let is_valid = true;
                switch (target.name) {
                    case 'username':
                        this.errors.username = '';
                        if (this.user.username.length < 8 || this.user.username.length > 15) {
                            this.errors.username = "enter_your_username_8_15_characters";
                            is_valid = false;
                        }
                        if (this.regexSpecialChar(this.user.username)) {
                            this.errors.username = "username_not_special_characters";
                            is_valid = false;
                        }
                        if (this.validateVietnameseChar(this.user.username)) {
                            this.errors.username = "username_invaild";
                            is_valid = false;
                        }
                        break;
                    case 'email':
                        this.errors.email = '';
                        if (!this.validateEmail(this.user.email)) {
                            this.errors.email = "email_is_not_constrain_email_format";
                            is_valid = false;
                        }
                        break;
                    case 'password':
                        this.errors.password = '';
                        if (this.user.password == '') {
                            this.errors.password = "password_not_empty";
                            is_valid = false;
                        }
                        // if (!this.isValidPassword(this.user.password)) {
                        if (this.user.password.length < 8) {
                            // this.errors.password = "Password must be at least 8 characters, contain letters, numbers and special characters";
                            this.errors.password = "password_at_least_8_characters";
                            is_valid = false;
                        }
                        if (this.validateVietnameseChar(this.user.password)) {
                            this.errors.password = "password_invaild";
                            is_valid = false;
                        }
                        break;
                    case 'password_confirm':
                        this.errors.password_confirm = '';
                        if (this.user.password_confirm == '') {
                            this.errors.password_confirm = "confirm_password_not_empty";
                            is_valid = false;
                        }
                        if (this.user.password_confirm != this.user.password) {
                            this.errors.password_confirm = "confirm_password_wrong";
                            is_valid = false;
                        }
                        break;
                }
                return is_valid;
            },
            isNumeric(value) {
                return /^\d+$/.test(value);
            },
            validateEmail(value) {
                let is_valid = false;
                if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value)) {
                    is_valid = true;
                }
                return is_valid;
            },
            // isValidPassword(pass) {
            //     // var lowerRegex = /[a-z]/;
            //     // var numberRegex = /[0-9]/;
            //     // var specialRegex = /[ !"#$%&'()*+,-./:;<=>?@[\\\]^_`{|}~]/;
            //     if (pass.length < 8 || pass.length > 64) {
            //         return false;
            //     }
            //     // if (pass.match(lowerRegex) &&
            //     //     pass.match(numberRegex) && pass.match(specialRegex)) {
            //     //     return true;
            //     // }
            //     return false;
            // },
            onSubmit(e) {
                const that = this;
                const params = cloneDeep(this.user);
                params.birthday = this.formatDate(params.birthday)
                delete params.password_confirm
                if(this.role_type == 1){
                    delete params.gender
                    delete params.grade
                } else {
                    delete params.relationship
                }
                if (that.user_info && that.user_info.student_type == 2) {
                    authAnonymous(formData).then((data) => {
                        that.$store.commit("setLoading", false);
                        if (data.data.code == 0) {
                            if (that.role_type == 1) {
                                $('#RegisterSuccessPopup').modal('show');
                            }
                            that.$store.commit('setAuth', true);
                            localStorage.removeItem('checkedSubjects');
                        }
                        else {
                            showDialog('error', 'Error', data.data.results);
                        }
                    }).catch(({response}) => {
                        that.$store.commit("setLoading", false);
                        showDialog('error', 'Error', response.data.results);
                    });
                } else {
                    authRegister(params).then((data) => {
                        that.$store.commit("setLoading", false);
                        if (data.data.code == 0) {
                            // $('#RegisterPopup').modal('hide');
                            if (that.role_type == 1) {
                                that.$store.commit("SET_ROLE_TYPE", 'parent');
                                $('#RegisterSuccessPopup').modal('show');
                            } else {
                                that.$store.commit("SET_ROLE_TYPE", 'student');
                                $('#RegisterStudentSuccessPopup').modal('show');
                                // window.location.href = '/'
                            }
                            that.$store.commit('setAuth', true);
                            localStorage.setItem('access_token', data.data.results.access_token);
                            localStorage.removeItem('checkedSubjects');
                        }
                        else {
                            if(localStorage.getItem('lang') == "vi"){
                                if(data.data.results == "Can not registry new account. Passwords must be at least 8 characters.."){
                                    data.data.results = "không thể đăng kí tài khoản mới. Mật khẩu phải có ít nhất 8 kí tự."
                                }else if(data.data.results == "Username had exist") {
                                    data.data.results = "Tài khoản đã tồn tại"
                                }else if(data.data.results == "Email has registered anorther account.") {
                                    data.data.results = "Email đã được đăng kí bởi tài khoản khác"
                                }else if(data.data.results == "Your phone number is already used") {
                                    data.data.results = "Số điện thoại đã được đăng kí bởi tài khoản khác."
                                }
                                else {
                                    data.data.results = "không thể đăng kí tài khoản mới. Email không hợp lệ."
                                }
                            }else{
                                if(data.data.results == "Can not registry new account. Passwords must be at least 8 characters.."){
                                    data.data.results = "Can not registry new account. Passwords must be at least 8 characters."
                                }else if(data.data.results == "Username had exist") {
                                    data.data.results = "Username had exist"
                                }else if(data.data.results == "Email has registered anorther account.") {
                                    data.data.results = "Email has registered anorther account."
                                }else if(data.data.results == "Your phone number is already used") {
                                    data.data.results = "Your phone number is already used."
                                }
                                else {
                                    data.data.results = "Can not registry new account. Email is invalid."
                                }
                            }
                            showDialog('error', 'Error', data.data.results);
                        }
                    }).catch(({response}) => {
                        that.$store.commit("setLoading", false);
                        // console.log('ect',response);
                        // alert(response.data.results);
                        showDialog('error', 'Error', response.data.results);
                    });
                }
            },

            resetErrorsValid() {
                this.error = {
                    message: '',
                    field_username: '',
                    field_password: ''
                }
            },

            regexSpecialChar(txt) {
                var specialRegex = /[!"#$%&'()*+,-./:;<=>?@[\\\]^_`{|}~]/;
                if (txt.match(specialRegex)) {
                    return true;
                }
                return false;
            },
            validateVietnameseChar(value) {
                var reGex = /[àÀảẢãÃáÁạẠăĂằẰẳẲẵẴắẮặẶâÂầẦẩẨẫẪấẤậẬđĐèÈẻẺẽẼéÉẹẸêÊềỀểỂễỄếẾệỆìÌỉỈĩĨíÍịỊòÒỏỎõÕóÓọỌôÔồỒổỔỗỖốỐộỘơƠờỜởỞỡỠớỚợỢùÙủỦũŨúÚụỤưƯừỪửỬữỮứỨựỰỳỲỷỶỹỸýÝỵỴ ]/;
                if (value.match(reGex)) {
                    return true;
                }
                return false;
            },
        }
    }
</script>

<style scoped>
    .ito-input {
        width: 100%;
    }

    .screen-show {
        display: block;
    }

    .screen-hide {
        display: none;
    }

    .form-control[readonly] {
        background-color: #ffffff;
    }
    .box-auth-main{
        min-height: unset !important;
        margin-bottom: 300px !important;   
    }
    .lisa-btn-fit{
        display: flex;
        align-items: center;
        /* width: 72px !important; */
        height: 36px;
        margin-top: 8px;
    }
    .lisa-btn-fit p{
        margin: 0;
    }
    .auth-box-title{
        font-size: 20px;
        letter-spacing: 0.02em;
        color: #070A28;
        margin-bottom: 12px !important;
    }

    .error-message{
        font-size: 14px;
        color: #E84343;
        margin-top: 12px;
    }
    .icon-birthday{
        display: inline;
        position: absolute;
        right: 13px;
        bottom: 25px;
        cursor: pointer;
    }
    #RegisterSuccessPopup .modal-content{
        width: 416px;
        height: 232px;
        padding: 20px 20px 24px !important;
    }
    #RegisterSuccessPopup .popup-title{
        margin: 0 auto 28px!important;
        font-size: 24px;
    }
    #RegisterSuccessPopup p{
        color: #070A28;
        font-weight: 400;
        font-size: 14px;
        text-align: center;
    }
    #RegisterSuccessPopup p:nth-child(4){
        margin-bottom: 32px !important;
    }
    #RegisterSuccessPopup .lisa-btn{
        width: 160px;
        height: 36px;
        display: flex;
        justify-content: center;
    }

    /* #content{

    } */

    #RegisterStudentSuccessPopup .modal-content{
        /* height: 168px; */
        width: 432px;
        padding: 12px 23px 18px;
    }
    #RegisterStudentSuccessPopup .popup-title{
        margin: 0 auto 8px!important;
        font-size: 18px;
    }
    #RegisterStudentSuccessPopup p{
        color: #070A28;
        font-weight: 400;
        font-size: 12px;
        text-align: center;
    }
    #RegisterStudentSuccessPopup p:nth-child(3){
        margin-bottom: 21px !important;
    }
    #RegisterStudentSuccessPopup .lisa-btn{
        width: 160px;
        height: 36px;
        display: flex;
        justify-content: center;
    }
    #RegisterStudentSuccessPopup .form-group{
        padding: 0 27px;
    }
    .icon-closed{
        position: absolute;
        cursor: pointer;
    }
    #RegisterSuccessPopup .icon-closed{
        top: -8px;
        right: 0px;
    }
    #RegisterStudentSuccessPopup .icon-closed{
        top: 0px;
        right: -10px;
    }
    .register-back{
        cursor: pointer;
    }
    .box-auth-main>a>.icon-closed{
        right: 23px;
        top: 19px;
    }
</style>
